import { ReactNode } from "react"
import { Box, Modal, ModalRootProps } from "@mantine/core"
import styles from "./AppModal.module.css"

interface AppModalProps extends ModalRootProps {
	title: string
	titleSize?: string
	hasScrollableBody?: boolean
	footer?: ReactNode
}

export const AppModal = ({
	title,
	titleSize = "lg",
	hasScrollableBody = true,
	footer,
	...props
}: AppModalProps) => {
	const { children, p = "lg", ...rest } = props
	return (
		<Modal.Root {...rest} centered={rest.centered ?? true}>
			<Modal.Overlay />
			<Modal.Content>
				<Modal.Header className={styles.bg}>
					<Modal.Title mx="auto" fz={titleSize} fw={600} p={10}>
						{title}
					</Modal.Title>
					<Modal.CloseButton m={0} aria-label="Close dialog" />
				</Modal.Header>

				<Modal.Body
					className={
						hasScrollableBody ? styles.modalBody : styles.modalBodyNoScroll
					}
					p={p}
				>
					{children}
				</Modal.Body>
				<Box p="32" className={styles.bg}>
					{footer}
				</Box>
			</Modal.Content>
		</Modal.Root>
	)
}
